import * as React from 'react';
import { SectionTitle } from 'pages/Shipments/Dashboard/SectionTitle';
import { ChargesOverTime } from './ChargesOverTime';
import { useOverTimeData } from '../hooks';

const TOOLTIP_COPY =
  'How much per diem accrued during the date range selected. Charges are accrued to the date that the container was returned empty. Example: if a container was returned on March 17th, all per diem charges will be accrued to March 17th for that container.';

export const OverTimeSection: React.FC = () => {
  const { data, showHistoric, isLoading, calendarPeriod, errors } = useOverTimeData();
  return (
    <div className="space-y-4 px-4">
      <SectionTitle tooltip={TOOLTIP_COPY} title="Historical per diem charges over time" />
      <ChargesOverTime
        data={data}
        showHistoric={showHistoric}
        isLoading={isLoading}
        calendarPeriod={calendarPeriod}
        errors={errors}
      />
    </div>
  );
};
OverTimeSection.displayName = 'Shipments.HistoricalPerDiem.OverTimeSection';
